import { createSelector } from "reselect";
const selector = (state) => state.pos;

export default createSelector([selector], (data) => data);